(() => {
  const root = document.querySelector('[data-bfe-jewellery-upsell]');
  if (!root || root.dataset.initialized === 'true') return;
  root.dataset.initialized = 'true';

  const dialog = root.querySelector('.bfe-jewellery-upsell__dialog');
  const configNode = root.querySelector('[data-bfe-upsell-config]');
  const optionInputs = [...root.querySelectorAll('[data-bfe-upsell-option]')];
  const choiceButtons = [...root.querySelectorAll('[data-bfe-upsell-choice]')];
  const productImage = root.querySelector('.bfe-jewellery-upsell__image');
  const acceptButton = root.querySelector('[data-bfe-upsell-accept]');
  const skipButtons = [...root.querySelectorAll('[data-bfe-upsell-skip]')];
  const availability = root.querySelector('[data-bfe-upsell-availability]');
  const countdownWrap = root.querySelector('[data-bfe-upsell-countdown-wrap]');
  const countdownLabel = root.querySelector('[data-bfe-upsell-countdown-label]');
  const countdown = root.querySelector('[data-bfe-upsell-countdown]');
  const errorMessage = root.querySelector('[data-bfe-upsell-error]');
  const config = JSON.parse(configNode.textContent);
  const offerProduct = config.offerProduct;
  const resolvedKey = 'bfe-jewellery-upsell-resolved';
  const forceTest = new URLSearchParams(window.location.search).get('bfe_upsell_test') === '1';

  let pendingEventTarget = null;
  let pendingEventDetail = null;
  let previouslyFocused = null;
  let savedOverflow = '';
  let savedDocumentOverflow = '';
  let submitting = false;
  let offerExpired = false;
  let countdownTimer = null;
  let countdownEndsAt = 0;

  const countdownDuration = 5 * 60 * 1000;

  const renderCountdown = () => {
    if (!countdown) return;
    const remainingSeconds = Math.max(0, Math.ceil((countdownEndsAt - Date.now()) / 1000));
    const minutes = Math.floor(remainingSeconds / 60);
    const seconds = remainingSeconds % 60;
    countdown.textContent = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    countdown.setAttribute('datetime', `PT${minutes}M${seconds}S`);

    if (remainingSeconds > 0) return;
    offerExpired = true;
    window.clearInterval(countdownTimer);
    countdownTimer = null;
    countdownWrap?.classList.add('is-expired');
    if (countdownLabel) countdownLabel.textContent = 'Limited-time offer ended';
    updateAvailability();
  };

  const startCountdown = () => {
    window.clearInterval(countdownTimer);
    offerExpired = false;
    countdownEndsAt = Date.now() + countdownDuration;
    countdownWrap?.classList.remove('is-expired');
    if (countdownLabel) countdownLabel.textContent = 'Limited-time offer ends in';
    renderCountdown();
    countdownTimer = window.setInterval(renderCountdown, 1000);
  };

  const stopCountdown = () => {
    window.clearInterval(countdownTimer);
    countdownTimer = null;
  };

  const hasResolved = () => {
    if (forceTest) return false;
    try {
      return window.sessionStorage.getItem(resolvedKey) === 'true';
    } catch (error) {
      return false;
    }
  };

  const markResolved = () => {
    if (forceTest) return;
    try {
      window.sessionStorage.setItem(resolvedKey, 'true');
    } catch (error) {
      // The offer still works when session storage is unavailable.
    }
  };

  const selectedVariant = () => {
    const selectedOptions = optionInputs.map((input) => input.value);
    return offerProduct.variants.find((variant) =>
      variant.options.every((value, index) => value === selectedOptions[index])
    );
  };

  const imageForColour = (colour) => {
    const aliases = {
      blue: ['hoodie-blue-02'],
      beige: ['hoodie-beige-02'],
      navy: ['hoodie-navyblue-02'],
      pink: ['hoodie-pink-01'],
      white: ['hoodie-white-02'],
      black: ['hoodie-black-02'],
      brown: ['hoodie-brown-02']
    };
    const keys = aliases[String(colour).toLowerCase()] || [];
    const images = offerProduct.images || [];
    let image = null;

    for (const key of keys) {
      image = images.find((url) => String(url).toLowerCase().includes(key));
      if (image) break;
    }

    return image || offerProduct.featured_image || images[0];
  };

  const updateProductImage = () => {
    if (!productImage || !optionInputs.length || root.hidden) return;
    const image = imageForColour(optionInputs[0].value);
    if (!image) return;
    const secureUrl = new URL(String(image), window.location.origin);
    if (productImage.dataset.imageSource === secureUrl.href) return;
    productImage.dataset.imageSource = secureUrl.href;
    const imageAtWidth = (width) => {
      const url = new URL(secureUrl.href);
      url.searchParams.set('width', width);
      return url.href;
    };
    // Keep responsive delivery when the offer opens or its color changes.
    productImage.sizes = '(max-width: 749px) min(76vw, 272px), min(47vw, 524px)';
    productImage.srcset = [360, 540, 720, 960, 1200].map((width) => `${imageAtWidth(width)} ${width}w`).join(', ');
    productImage.src = imageAtWidth(1200);
    productImage.alt = `${optionInputs[0].value} ${offerProduct.title}`;
  };

  const updateAvailability = () => {
    const variant = selectedVariant();
    const isAvailable = Boolean(variant && variant.available);
    choiceButtons.forEach((button) => {
      const position = Number(button.dataset.optionPosition) - 1;
      button.setAttribute('aria-pressed', String(optionInputs[position]?.value === button.dataset.optionValue));
    });
    updateProductImage();
    acceptButton.disabled = !isAvailable || submitting || offerExpired;
    availability.hidden = isAvailable;
    availability.textContent = isAvailable ? '' : 'This combination is currently unavailable';
    return variant;
  };

  const open = (eventTarget, eventDetail) => {
    pendingEventTarget = eventTarget;
    pendingEventDetail = eventDetail;
    previouslyFocused = document.activeElement;
    savedOverflow = document.body.style.overflow;
    savedDocumentOverflow = document.documentElement.style.overflow;
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
    root.hidden = false;
    startCountdown();
    requestAnimationFrame(() => {
      root.classList.add('is-open');
      dialog.focus({ preventScroll: true });
    });
    updateAvailability();
  };

  const close = (restoreFocus = true) => {
    stopCountdown();
    root.classList.remove('is-open');
    document.body.style.overflow = savedOverflow;
    document.documentElement.style.overflow = savedDocumentOverflow;
    window.setTimeout(() => {
      root.hidden = true;
      if (restoreFocus && previouslyFocused instanceof HTMLElement) previouslyFocused.focus({ preventScroll: true });
    }, 220);
  };

  const proceedToCart = () => {
    if (!pendingEventDetail || submitting) return;
    markResolved();
    close(false);

    if (window.themeVariables.settings.cartType === 'page' || window.themeVariables.settings.pageType === 'cart') {
      window.location.href = `${window.Shopify.routes.root}cart`;
      return;
    }

    const target = pendingEventTarget?.isConnected ? pendingEventTarget : document.documentElement;
    target.dispatchEvent(new CustomEvent('variant:add', {
      bubbles: true,
      detail: {
        ...pendingEventDetail,
        bfeUpsellResolved: true,
        blockCartDrawerOpening: false
      }
    }));
  };

  const setBusy = (busy) => {
    submitting = busy;
    acceptButton.toggleAttribute('aria-busy', busy);
    optionInputs.forEach((input) => { input.disabled = busy; });
    updateAvailability();
  };

  const addHoodie = async () => {
    if (!pendingEventDetail || submitting) return;
    const variant = updateAvailability();
    if (!variant || !variant.available) return;

    errorMessage.hidden = true;
    setBusy(true);

    try {
      const sections = ['variant-added'];
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
        bubbles: true,
        detail: { sections }
      }));

      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          items: [
            {
              id: variant.id,
              quantity: 1,
              properties: { 'Impact': '40 meals funded' }
            }
          ],
          sections,
          sections_url: window.location.pathname
        })
      });

      const responseJson = await response.json();
      if (!response.ok) throw new Error(responseJson.description || 'We could not add this combination. Please try another option.');

      markResolved();
      close(false);

      if (window.themeVariables.settings.cartType === 'page' || window.themeVariables.settings.pageType === 'cart') {
        window.location.href = `${window.Shopify.routes.root}cart`;
        return;
      }

      const cart = await (await fetch(`${window.Shopify.routes.root}cart.js`)).json();
      cart.sections = responseJson.sections;

      document.documentElement.dispatchEvent(new CustomEvent('variant:add', {
        bubbles: true,
        detail: {
          items: responseJson.items || [],
          cart,
          bfeUpsellResolved: true
        }
      }));

      document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
        bubbles: true,
        detail: {
          baseEvent: 'variant:add',
          cart
        }
      }));
    } catch (error) {
      errorMessage.textContent = error.message || 'Something went wrong. Please try again.';
      errorMessage.hidden = false;
    } finally {
      setBusy(false);
    }
  };

  document.addEventListener('variant:add', (event) => {
    const detail = event.detail || {};
    if (detail.bfeUpsellResolved || submitting) return;

    if (root.classList.contains('is-open')) {
      detail.blockCartDrawerOpening = true;
      return;
    }

    if (hasResolved()) return;
    const addedItems = Array.isArray(detail.items) ? detail.items : [];
    const containsSourceProduct = addedItems.some((item) => String(item.product_id) === String(config.sourceProductId));
    if (!containsSourceProduct) return;

    detail.blockCartDrawerOpening = true;
    open(event.target, detail);
  }, true);

  optionInputs.forEach((input) => input.addEventListener('change', updateAvailability));
  choiceButtons.forEach((button) => button.addEventListener('click', () => {
    const position = Number(button.dataset.optionPosition) - 1;
    const input = optionInputs[position];
    if (!input || submitting) return;
    input.value = button.dataset.optionValue;
    updateAvailability();
  }));
  acceptButton.addEventListener('click', addHoodie);
  skipButtons.forEach((button) => button.addEventListener('click', proceedToCart));

  document.addEventListener('keydown', (event) => {
    if (!root.classList.contains('is-open')) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      proceedToCart();
      return;
    }

    if (event.key === 'Tab') {
      const focusable = [...dialog.querySelectorAll('button:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])')];
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  });
})();
